(function (factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.PPSizeGuideLogic = api;
}(function () {
  'use strict';

  var ROOM_SCALE_PERCENT_PER_INCH = 47 / 67;
  var metadata = {
    '16x12': ['Approx. 23 × 19 in.', 'Desk, bedside, narrow wall, or gallery grouping'],
    '24x18': ['Approx. 31 × 25 in.', 'Accent chair, small console, or writing table'],
    '36x24': ['Approx. 43 × 31 in.', 'Console, fireplace wall, or tailored seating area'],
    '40x30': ['Approx. 47 × 37 in.', 'Sofa, bed, sideboard, or architectural bay'],
    '48x36': ['Approx. 55 × 43 in.', 'Primary wall above a sofa, bed, or long credenza'],
    '60x40': ['Approx. 67 × 47 in.', 'Large uninterrupted wall or statement placement'],
    '12x16': ['Approx. 19 × 23 in.', 'Desk, bedside, narrow wall, or gallery grouping'],
    '18x24': ['Approx. 25 × 31 in.', 'Accent chair, small console, or reading corner'],
    '24x36': ['Approx. 31 × 43 in.', 'Architectural bay, entry wall, or tailored seating area'],
    '30x40': ['Approx. 37 × 47 in.', 'Open wall beside a sofa, console, or lounge chair'],
    '36x48': ['Approx. 43 × 55 in.', 'Tall uninterrupted wall or prominent architectural bay'],
    '40x60': ['Approx. 47 × 67 in.', 'Large vertical wall with generous viewing distance']
  };

  function parseDimension(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;

    var match = String(value).trim().match(
      /^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:["″”]|in(?:\.|ch(?:es)?)?)?$/i
    );
    if (!match) return null;

    var width = Number(match[1]);
    var height = Number(match[2]);
    if (!isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) return null;

    return { width: width, height: height, key: String(width) + 'x' + String(height) };
  }

  function metadataFor(value) {
    var dimension = parseDimension(value);
    if (!dimension) return null;

    var record = metadata[dimension.key];
    var geometry = compositeGeometry(value);

    return {
      finished: record
        ? record[0]
        : 'Approx. ' + formatInches(geometry.finishedWidth) + ' × ' + formatInches(geometry.finishedHeight) + ' in.',
      placement: record ? record[1] : suggestedPlacementFor(geometry)
    };
  }

  function formatInches(value) {
    return String(Math.round(value * 100) / 100);
  }

  function suggestedPlacementFor(geometry) {
    var longestSide = Math.max(geometry.finishedWidth, geometry.finishedHeight);

    if (longestSide <= 25) return 'Desk, bedside, narrow wall, or gallery grouping';
    if (longestSide <= 32) return 'Accent chair, small console, or writing table';
    if (longestSide <= 44) return 'Console, fireplace wall, or tailored seating area';
    if (longestSide <= 56) return 'Sofa, bed, sideboard, or architectural bay';
    return 'Large uninterrupted wall or statement placement';
  }

  function compositeGeometry(value) {
    var dimension = parseDimension(value);
    if (!dimension) return null;

    var matWidth = 2;
    var frameRailWidth = 1.5;
    var matOuterWidth = dimension.width + (matWidth * 2);
    var matOuterHeight = dimension.height + (matWidth * 2);
    var finishedWidth = matOuterWidth + (frameRailWidth * 2);
    var finishedHeight = matOuterHeight + (frameRailWidth * 2);

    return {
      artworkWidth: dimension.width,
      artworkHeight: dimension.height,
      matWidth: matWidth,
      frameRailWidth: frameRailWidth,
      matOuterWidth: matOuterWidth,
      matOuterHeight: matOuterHeight,
      finishedWidth: finishedWidth,
      finishedHeight: finishedHeight,
      frameRatio: finishedWidth / finishedHeight,
      frameRailPercent: (frameRailWidth / finishedWidth) * 100,
      matPercent: (matWidth / matOuterWidth) * 100
    };
  }

  function frameRailStagePercent(value, frameWidthPercent) {
    var geometry = compositeGeometry(value);
    var frameWidth = Number(frameWidthPercent);
    if (!geometry || !isFinite(frameWidth) || frameWidth <= 0) return null;
    return frameWidth * (geometry.frameRailPercent / 100);
  }

  function frameWidthPercent(value) {
    var geometry = compositeGeometry(value);
    if (!geometry) return null;
    return Math.round(geometry.finishedWidth * ROOM_SCALE_PERCENT_PER_INCH * 100) / 100;
  }

  function normalizedText(value) {
    return typeof value === 'string' || typeof value === 'number'
      ? String(value).trim().replace(/\s+/g, ' ').toLowerCase()
      : null;
  }

  function sizeOptionIndex(optionNames, variants) {
    var names = Array.isArray(optionNames) ? optionNames : [];
    var items = Array.isArray(variants) ? variants : [];
    var namedIndex = names.findIndex(function (name) {
      return normalizedText(name) === 'size';
    });
    if (namedIndex !== -1) return namedIndex;

    var optionCount = names.length;
    items.forEach(function (variant) {
      if (variant && Array.isArray(variant.options)) {
        optionCount = Math.max(optionCount, variant.options.length);
      }
    });

    for (var index = 0; index < optionCount; index += 1) {
      if (items.length && items.every(function (variant) {
        return variant && Array.isArray(variant.options) && parseDimension(variant.options[index]);
      })) return index;
    }

    return -1;
  }

  function variantForSize(variants, optionNames, selectedOptions, requestedSize) {
    var items = Array.isArray(variants) ? variants : [];
    var names = Array.isArray(optionNames) ? optionNames : [];
    var selected = Array.isArray(selectedOptions) ? selectedOptions : [];
    var sizeIndex = sizeOptionIndex(names, items);
    var requested = parseDimension(requestedSize);
    var emptyResult = { variant: null, exists: false, available: false, existsForOtherOptions: false };

    if (sizeIndex === -1 || !requested) return emptyResult;

    var candidates = items.filter(function (variant) {
      var option = variant && Array.isArray(variant.options) ? variant.options[sizeIndex] : null;
      var parsed = parseDimension(option);
      return parsed && parsed.key === requested.key;
    });

    if (!candidates.length) return emptyResult;

    function preservesNonSizeOptions(variant) {
      var options = variant && Array.isArray(variant.options) ? variant.options : [];
      var optionCount = Math.max(names.length, selected.length, options.length);

      for (var index = 0; index < optionCount; index += 1) {
        if (index === sizeIndex) continue;
        if (selected[index] !== options[index]) return false;
      }
      return true;
    }

    var exactVariant = candidates.find(preservesNonSizeOptions) || null;
    var existsForOtherOptions = candidates.some(function (variant) {
      return !preservesNonSizeOptions(variant);
    });

    return {
      variant: exactVariant,
      exists: true,
      available: Boolean(exactVariant && exactVariant.available),
      existsForOtherOptions: existsForOtherOptions
    };
  }

  function availableSizeValues(variants, optionNames, selectedOptions) {
    var items = Array.isArray(variants) ? variants : [];
    var names = Array.isArray(optionNames) ? optionNames : [];
    var sizeIndex = sizeOptionIndex(names, items);
    var seen = {};
    var values = [];

    if (sizeIndex === -1) return values;

    items.forEach(function (variant) {
      var options = variant && Array.isArray(variant.options) ? variant.options : [];
      var value = options[sizeIndex];
      var dimension = parseDimension(value);
      if (!dimension || seen[dimension.key]) return;
      seen[dimension.key] = true;
      if (variantForSize(items, names, selectedOptions, value).available) values.push(value);
    });

    return values;
  }

  function orientationFor(value) {
    var dimension = parseDimension(value);
    return dimension && dimension.height > dimension.width ? 'portrait' : 'landscape';
  }

  return {
    parseDimension: parseDimension,
    metadataFor: metadataFor,
    compositeGeometry: compositeGeometry,
    frameWidthPercent: frameWidthPercent,
    frameRailStagePercent: frameRailStagePercent,
    sizeOptionIndex: sizeOptionIndex,
    variantForSize: variantForSize,
    availableSizeValues: availableSizeValues,
    orientationFor: orientationFor
  };
}));
